export default {"src":"/_next/static/media/PAAS.3914cbc0.svg","height":18,"width":18};